import React, { memo } from 'react';
import PropTypes from 'prop-types';
import TicketsComponent1 from '../../../uiElements/ticketsComponents/ticketComponent1/TicketsComponent1';

const GameTickets1 = (props) => {
    const { tickets, showTickets, loadingSpinner } = props;

    return (
        <div className="x-center m-t-30px">
            {showTickets ? (
                <TicketsComponent1 tickets={tickets} loadingSpinner={loadingSpinner} />
            ) : <p className="schedule1-games-unavailable-text alegreya-font-family font-weight-800 font-size-6xl full-width text-center-align m-t-100px text-uppercase">Tickets not available</p>}
        </div>
    );
};

GameTickets1.propTypes = {
    tickets: PropTypes.array.isRequired,
    showTickets: PropTypes.bool.isRequired,
    loadingSpinner: PropTypes.bool.isRequired,
};

export default memo(GameTickets1);
